"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _variable = _interopRequireDefault(require("./variable"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TimerVariable = /*#__PURE__*/function (_Variable) {
  function TimerVariable(variable) {
    (0, _classCallCheck2["default"])(this, TimerVariable);
    Entry.assert(variable.variableType === 'timer', 'Invalid variable type given');
    return _callSuper(this, TimerVariable, [variable]);
  }
  (0, _inherits2["default"])(TimerVariable, _Variable);
  return (0, _createClass2["default"])(TimerVariable, [{
    key: "updateView",
    value: function updateView() {
      if (!this.view_) {
        return;
      }
      if (this.isVisible()) {
        this._adjustSingleViewPosition();
        this.textView_.text = this.getName();
        if (this._nameWidth === null) {
          this._nameWidth = this.textView_.getMeasuredWidth();
        }
        this._adjustSingleValueViewPosition();
        if (this.isNumber()) {
          this.valueView_.text = Number(this.getValue()).toFixed(1).replace('.00', '');
        } else {
          this.valueView_.text = this.getValue();
        }
        if (this._valueWidth === null) {
          this._valueWidth = this.valueView_.getMeasuredWidth();
        }
        this._adjustSingleViewBox('#f4af18');
      }
      Entry.requestUpdate = true;
    }
  }]);
}(_variable["default"]);
var _default = exports["default"] = TimerVariable;